import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base-http.service';

/**
 * Rendszer egészségügyi metrikák interface
 */
export interface SystemHealthMetrics {
  cpu_percent: number;
  cpu_count: number;
  cpu_count_logical: number;
  load_avg_1min: number;
  load_avg_5min: number;
  load_avg_15min: number;
  memory_total_mb: number;
  memory_used_mb: number;
  memory_available_mb: number;
  memory_percent: number;
  swap_total_mb: number;
  swap_used_mb: number;
  swap_percent: number;
  disk_total_gb: number;
  disk_used_gb: number;
  disk_free_gb: number;
  disk_percent: number;
  disk_read_mb: number;
  disk_write_mb: number;
  network_sent_mb: number;
  network_recv_mb: number;
  uptime_seconds: number;
  uptime_formatted: string;
  cached_at: string;
}

/**
 * Adatbázis egészségügyi metrikák interface
 */
export interface DatabaseHealthMetrics {
  active_connections: number;
  total_connections: number;
  max_connections: number;
  connection_percent: number;
  database_size_mb: number;
  cached_at: string;
}

/**
 * History pont interface-ek
 */
export interface HistoryPoint {
  timestamp: string;
  cpu_percent: number;
  memory_percent: number;
  disk_percent: number;
  network_sent_mb: number;
  network_recv_mb: number;
}

export interface DatabaseHistoryPoint {
  timestamp: string;
  active_connections: number;
  total_connections: number;
  connection_percent: number;
  database_size_mb: number;
}

export interface SystemHistoryResponse {
  current: SystemHealthMetrics;
  history: HistoryPoint[];
}

export interface DatabaseHistoryResponse {
  current: DatabaseHealthMetrics;
  history: DatabaseHistoryPoint[];
}

/**
 * Frissítési intervallum opció
 */
export interface RefreshIntervalOption {
  label: string;
  value: number;
}

/**
 * Elérhető frissítési intervallumok
 */
export const REFRESH_INTERVALS: RefreshIntervalOption[] = [
  { label: '1 mp', value: 1000 },
  { label: '5 mp', value: 5000 },
];

/**
 * Monitoring Service - VPS rendszer és adatbázis metrikák lekérdezése
 *
 * A service a BaseHttpService-t használja az API hívásokhoz,
 * automatikus token kezeléssel és hibakezeléssel.
 */
@Injectable({
  providedIn: 'root'
})
export class MonitoringService extends BaseHttpService {

  /**
   * Rendszer erőforrás metrikák lekérdezése
   */
  getSystemHealth(): Observable<SystemHealthMetrics> {
    return this.get<SystemHealthMetrics>('/api/system/health');
  }

  /**
   * PostgreSQL adatbázis metrikák lekérdezése
   */
  getDatabaseHealth(): Observable<DatabaseHealthMetrics> {
    return this.get<DatabaseHealthMetrics>('/api/system/database');
  }

  /**
   * Rendszer metrikák history lekérdezése
   */
  getSystemHealthHistory(limit: number = 60): Observable<SystemHistoryResponse> {
    return this.get<SystemHistoryResponse>(`/api/system/health/history?limit=${limit}`);
  }

  /**
   * Adatbázis metrikák history lekérdezése
   */
  getDatabaseHealthHistory(limit: number = 60): Observable<DatabaseHistoryResponse> {
    return this.get<DatabaseHistoryResponse>(`/api/system/database/history?limit=${limit}`);
  }
}
